export const agglosEnum = [
    {
        "id": "agde", "name": "Agde", "region": {
            "center": {
                "type": "Point", "coordinates": [3.4882, 43.2956]
            }
            , "osmLevel": 8
        },
    },
    {
        "id": "agen", "name": "Agen", "region": {
            "center": {
                "type": "Point", "coordinates": [0.6294, 44.2085]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "aix-en-provence", "name": "Aix-en-Provence", "region": {
            "center": {
                "type": "Point", "coordinates": [5.3967, 43.5097]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "ajaccio", "name": "Ajaccio", "region": {
            "center": {
                "type": "Point", "coordinates": [8.6694, 41.932]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "albertville", "name": "Albertville", "region": {
            "center": {
                "type": "Point", "coordinates": [6.4029, 45.6733]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "albi", "name": "Albi", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1448, 43.9173]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "alencon", "name": "Alençon", "region": {
            "center": {
                "type": "Point", "coordinates": [0.0931, 48.4284]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "ales", "name": "Alès", "region": {
            "center": {
                "type": "Point", "coordinates": [4.0917, 44.1241]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "allauch", "name": "Allauch", "region": {
            "center": {
                "type": "Point", "coordinates": [5.5011, 43.3475]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "amberieu-en-bugey", "name": "Ambérieu-en-Bugey", "region": {
            "center": {
                "type": "Point", "coordinates": [5.3775, 45.9594]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "amboise", "name": "Amboise", "region": {
            "center": {
                "type": "Point", "coordinates": [1.0101, 47.3978]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "amiens", "name": "Amiens", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2924, 49.8935]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "angers", "name": "Angers", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.5628, 47.4776]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "angouleme", "name": "Angouleme", "region": {
            "center": {
                "type": "Point", "coordinates": [0.148, 45.6466]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "annecy", "name": "Annecy", "region": {
            "center": {
                "type": "Point", "coordinates": [6.1014, 45.8985]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "annemasse", "name": "Annemasse", "region": {
            "center": {
                "type": "Point", "coordinates": [6.2435, 46.1919]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "annonay", "name": "Annonay", "region": {
            "center": {
                "type": "Point", "coordinates": [4.6513, 45.2433]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "antibes", "name": "Antibes", "region": {
            "center": {
                "type": "Point", "coordinates": [7.1178, 43.5734]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "antony", "name": "Antony", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2957, 48.7487]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "argentan", "name": "Argentan", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.0089, 48.7256]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "arles", "name": "Arles", "region": {
            "center": {
                "type": "Point", "coordinates": [4.6489, 43.5272]
            }
        }
        , "osmLevel": 8
    },
    {
        "id": "arnouville", "name": "Arnouville", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4165, 48.9847]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "arras", "name": "Arras", "region": {
            "center": {
                "type": "Point", "coordinates": [2.7659, 50.2895]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "aubagne", "name": "Aubagne", "region": {
            "center": {
                "type": "Point", "coordinates": [5.551, 43.2971]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "aubenas", "name": "Aubenas", "region": {
            "center": {
                "type": "Point", "coordinates": [4.391, 44.6126]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "auch", "name": "Auch", "region": {
            "center": {
                "type": "Point", "coordinates": [0.5718, 43.6602]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "aulnay-sous-bois", "name": "Aulnay-sous-Bois", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4948, 48.9417]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "auray", "name": "Auray", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.9885, 47.6643]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "autun", "name": "Autun", "region": {
            "center": {
                "type": "Point", "coordinates": [4.3074, 46.9466]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "auxerre", "name": "Auxerre", "region": {
            "center": {
                "type": "Point", "coordinates": [3.5943, 47.8066]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "avignon", "name": "Avignon", "region": {
            "center": {
                "type": "Point", "coordinates": [4.8465, 43.946]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bagnoles-de-l-orne", "name": "Bagnoles-de-l'Orne", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.4205, 48.5677]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bagnols-sur-ceze", "name": "Bagnols-sur-Cèze", "region": {
            "center": {
                "type": "Point", "coordinates": [4.623, 44.1581]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bar-le-duc", "name": "Bar-le-Duc", "region": {
            "center": {
                "type": "Point", "coordinates": [5.1668, 48.7685]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bassin-d-arcachon", "name": "Bassin d'Arcachon", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.174, 44.6541]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "aurillac", "name": "Bassin d'Aurillac", "region": {
            "center": {
                "type": "Point", "coordinates": [2.445, 44.9271]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bassin-de-briey", "name": "Bassin de Briey", "region": {
            "center": {
                "type": "Point", "coordinates": [5.9566, 49.2617]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bassin-de-pompey", "name": "Bassin de Pompey", "region": {
            "center": {
                "type": "Point", "coordinates": [6.1073, 48.7713]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bastia", "name": "Bastia", "region": {
            "center": {
                "type": "Point", "coordinates": [9.4372, 42.6927]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bayeux", "name": "Bayeux", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.7018, 49.2765]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bayonne", "name": "Bayonne", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.4718, 43.4851]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "beauchamps", "name": "Beauchamps", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.3649, 48.8369]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "beaumont-sur-oise", "name": "Beaumont-sur-Oise", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3014, 49.1394]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "beaune", "name": "Beaune", "region": {
            "center": {
                "type": "Point", "coordinates": [4.8383, 47.026]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "beauvais", "name": "Beauvais", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0851, 49.4393]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "belfort", "name": "Belfort", "region": {
            "center": {
                "type": "Point", "coordinates": [6.8381, 47.6496]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bernay", "name": "Bernay", "region": {
            "center": {
                "type": "Point", "coordinates": [0.5962, 49.0892]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "berre-l-etang", "name": "Berre-l'Étang", "region": {
            "center": {
                "type": "Point", "coordinates": [5.0919, 43.4874]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "besancon", "name": "Besancon", "region": {
            "center": {
                "type": "Point", "coordinates": [6.0285, 47.26]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "beziers", "name": "Béziers", "region": {
            "center": {
                "type": "Point", "coordinates": [3.2358, 43.3596]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "blois", "name": "Blois", "region": {
            "center": {
                "type": "Point", "coordinates": [1.3161, 47.5856]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bolbec", "name": "Bolbec", "region": {
            "center": {
                "type": "Point", "coordinates": [0.4819, 49.572]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bollene", "name": "Bollène", "region": {
            "center": {
                "type": "Point", "coordinates": [4.7442, 44.2896]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bonneville", "name": "Bonneville", "region": {
            "center": {
                "type": "Point", "coordinates": [6.4078, 46.0808]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bonnieres-sur-seine", "name": "Bonnières-sur-Seine", "region": {
            "center": {
                "type": "Point", "coordinates": [1.5688, 49.0149]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bordeaux", "name": "Bordeaux", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.5874, 44.8572]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "boulogne-sur-mer", "name": "Boulogne-sur-Mer", "region": {
            "center": {
                "type": "Point", "coordinates": [1.6064, 50.7289]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bourg-en-bresse", "name": "Bourg-en-Bresse", "region": {
            "center": {
                "type": "Point", "coordinates": [5.2444, 46.2062]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bourges", "name": "Bourges", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3987, 47.0827]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bourgoin-jallieu", "name": "Bourgoin-Jallieu", "region": {
            "center": {
                "type": "Point", "coordinates": [5.288, 45.5943]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bray-sur-seine", "name": "Bray-sur-Seine", "region": {
            "center": {
                "type": "Point", "coordinates": [3.2439, 48.4176]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bressuire", "name": "Bressuire", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.4818, 46.8603]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "brest", "name": "Brest", "region": {
            "center": {
                "type": "Point", "coordinates": [-4.5058, 48.4059]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "bretigny-sur-orge", "name": "Brétigny-sur-Orge", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2986, 48.6057]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "briancon", "name": "Briançon", "region": {
            "center": {
                "type": "Point", "coordinates": [6.6421, 44.8976]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "brie-comte-robert", "name": "Brie-Comte-Robert", "region": {
            "center": {
                "type": "Point", "coordinates": [2.6165, 48.6855]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "brive-la-gaillarde", "name": "Brive-la-Gaillarde", "region": {
            "center": {
                "type": "Point", "coordinates": [1.5155, 45.1393]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "caen", "name": "Caen", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.3719, 49.1798]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cahors", "name": "Cahors", "region": {
            "center": {
                "type": "Point", "coordinates": [1.4339, 44.4473]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "calais", "name": "Calais", "region": {
            "center": {
                "type": "Point", "coordinates": [1.8749, 50.9596]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cannes", "name": "Cannes", "region": {
            "center": {
                "type": "Point", "coordinates": [7.0191, 43.5384]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "carcassonne", "name": "Carcassonne", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3567, 43.2091]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "carhaix-plouguer", "name": "Carhaix-Plouguer", "region": {
            "center": {
                "type": "Point", "coordinates": [-3.5588, 48.2717]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "carpentras", "name": "Carpentras", "region": {
            "center": {
                "type": "Point", "coordinates": [5.0582, 44.0625]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "carry-le-rouet", "name": "Carry-Le-Rouet", "region": {
            "center": {
                "type": "Point", "coordinates": [5.1543, 43.3352]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cassis", "name": "Cassis", "region": {
            "center": {
                "type": "Point", "coordinates": [5.5372, 43.2126]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "castres", "name": "Castres", "region": {
            "center": {
                "type": "Point", "coordinates": [3.2512, 49.8044]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cavaillon", "name": "Cavaillon", "region": {
            "center": {
                "type": "Point", "coordinates": [5.0563, 43.8433]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cayenne", "name": "Cayenne", "region": {
            "center": {
                "type": "Point", "coordinates": [-52.2791, 4.9273]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cergy-pontoise", "name": "Cergy-Pontoise", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0609, 49.0196]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "challans", "name": "Challans", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.8487, 46.836]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chalon-sur-saone", "name": "Chalon-sur-Saône", "region": {
            "center": {
                "type": "Point", "coordinates": [4.8438, 46.789]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chalons-en-champagne", "name": "Châlons-en-Champagne", "region": {
            "center": {
                "type": "Point", "coordinates": [4.3737, 48.9556]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chambery", "name": "Chambéry", "region": {
            "center": {
                "type": "Point", "coordinates": [5.9117, 45.5793]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chantilly", "name": "Chantilly", "region": {
            "center": {
                "type": "Point", "coordinates": [2.477, 49.1792]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "charleville-mezieres", "name": "Charleville-Mézières", "region": {
            "center": {
                "type": "Point", "coordinates": [4.7198, 49.7783]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chartres", "name": "Chartres", "region": {
            "center": {
                "type": "Point", "coordinates": [1.499, 48.4483]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chateaubourg", "name": "Châteaubourg", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.4051, 48.1184]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chateauroux", "name": "Châteauroux", "region": {
            "center": {
                "type": "Point", "coordinates": [1.6918, 46.8069]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chatellerault", "name": "Châtellerault", "region": {
            "center": {
                "type": "Point", "coordinates": [0.5503, 46.8161]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chaumont", "name": "Chaumont", "region": {
            "center": {
                "type": "Point", "coordinates": [2.7522, 46.8416]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chaville", "name": "Chaville", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1903, 48.8114]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "chelles", "name": "Chelles", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5913, 48.8828]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cherbourg", "name": "Cherbourg", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.6439, 49.6387]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cholet", "name": "Cholet", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.8833, 47.0325]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cilaos", "name": "Cilaos", "region": {
            "center": {
                "type": "Point", "coordinates": [55.4559, -21.1431]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "clermont", "name": "Clermont", "region": {
            "center": {
                "type": "Point", "coordinates": [2.414, 49.3788]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "clermont-ferrand", "name": "Clermont-Ferrand", "region": {
            "center": {
                "type": "Point", "coordinates": [3.1074, 45.7825]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cluses", "name": "Cluses", "region": {
            "center": {
                "type": "Point", "coordinates": [6.5862, 46.0594]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "cognac", "name": "Cognac", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.3402, 45.6943]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "colmar", "name": "Colmar", "region": {
            "center": {
                "type": "Point", "coordinates": [7.3936, 48.1203]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "compiegne", "name": "Compiègne", "region": {
            "center": {
                "type": "Point", "coordinates": [2.8604, 49.4176]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "concarneau", "name": "Concarneau", "region": {
            "center": {
                "type": "Point", "coordinates": [-3.9109, 47.8797]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "conflans-sainte-honorine", "name": "Conflans-Sainte-Honorine", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0939, 48.9977]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "corbeil-essonnes", "name": "Corbeil-Essonnes", "region": {
            "center": {
                "type": "Point", "coordinates": [2.47, 48.5989]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "coulommiers", "name": "Coulommiers", "region": {
            "center": {
                "type": "Point", "coordinates": [3.0973, 48.8156]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "coutances", "name": "Coutances", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.4436, 49.0585]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "crecy-la-chapelle", "name": "Crécy la Chapelle", "region": {
            "center": {
                "type": "Point", "coordinates": [2.9186, 48.8554]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "creil", "name": "Creil", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4799, 49.2555]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "creil-sud-oise", "name": "Creil Sud Oise", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4799, 49.2555]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "crepy-en-valois", "name": "Crépy-en-Valois", "region": {
            "center": {
                "type": "Point", "coordinates": [2.8998, 49.2307]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "creusot-montceau", "name": "Creusot-Montceau", "region": {
            "center": {
                "type": "Point", "coordinates": [4.4276, 46.8089]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dammartin-en-goele", "name": "Dammartin-en-Goële", "region": {
            "center": {
                "type": "Point", "coordinates": [2.6755, 49.0536]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dax", "name": "Dax", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.0562, 43.7016]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "decazeville", "name": "Decazeville", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2575, 44.5682]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dieppe", "name": "Dieppe", "region": {
            "center": {
                "type": "Point", "coordinates": [1.0827, 49.9225]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "digne-les-bains", "name": "Digne-les-Bains", "region": {
            "center": {
                "type": "Point", "coordinates": [6.2513, 44.0883]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dijon", "name": "Dijon", "region": {
            "center": {
                "type": "Point", "coordinates": [5.0377, 47.3238]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dinan", "name": "Dinan", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.0483, 48.4499]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dinard", "name": "Dinard", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.057, 48.6291]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dole", "name": "Dole", "region": {
            "center": {
                "type": "Point", "coordinates": [5.488, 47.0798]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "douai", "name": "Douai", "region": {
            "center": {
                "type": "Point", "coordinates": [3.0962, 50.3858]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "douarnenez", "name": "Douarnenez", "region": {
            "center": {
                "type": "Point", "coordinates": [-4.333, 48.0843]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "draguignan", "name": "Draguignan", "region": {
            "center": {
                "type": "Point", "coordinates": [6.4467, 43.5402]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dreux", "name": "Dreux", "region": {
            "center": {
                "type": "Point", "coordinates": [1.3579, 48.7493]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "dunkerque", "name": "Dunkerque", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3386, 51.0346]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "eaubonne", "name": "Eaubonne", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2777, 48.9915]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "epernay", "name": "Epernay", "region": {
            "center": {
                "type": "Point", "coordinates": [3.9311, 49.0366]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "epinal", "name": "Épinal", "region": {
            "center": {
                "type": "Point", "coordinates": [6.4766, 48.1688]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "epinay-sur-orge", "name": "Épinay-sur-Orge", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3221, 48.6705]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "ermont", "name": "Ermont", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2599, 48.988]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "etampes", "name": "Étampes", "region": {
            "center": {
                "type": "Point", "coordinates": [2.153, 48.4233]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "evreux", "name": "Évreux", "region": {
            "center": {
                "type": "Point", "coordinates": [1.1428, 49.0249]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "evry", "name": "Évry", "region": {
            "center": {
                "type": "Point", "coordinates": [3.2613, 48.273]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "fecamp", "name": "Fécamp", "region": {
            "center": {
                "type": "Point", "coordinates": [0.4003, 49.7487]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "figeac", "name": "Figeac", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0234, 44.6057]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "flers", "name": "Flers", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.5645, 48.7405]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "foix", "name": "Foix", "region": {
            "center": {
                "type": "Point", "coordinates": [1.6101, 42.9624]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "fontainebleau", "name": "Fontainebleau", "region": {
            "center": {
                "type": "Point", "coordinates": [2.6876, 48.419]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "fontenay-le-comte", "name": "Fontenay-le-comte", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.8012, 46.4598]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "fontenay-le-fleury", "name": "Fontenay-le-Fleury", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0444, 48.8157]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "fougeres", "name": "Fougères", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.1981, 48.3473]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "franconville", "name": "Franconville", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2224, 48.9841]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "gaillac", "name": "Gaillac", "region": {
            "center": {
                "type": "Point", "coordinates": [1.8916, 43.9212]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "gemenos", "name": "Gémenos", "region": {
            "center": {
                "type": "Point", "coordinates": [5.6486, 43.2955]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "granville", "name": "Granville", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.7353, 48.8629]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "grasse", "name": "Grasse", "region": {
            "center": {
                "type": "Point", "coordinates": [6.937, 43.6552]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "grenoble", "name": "Grenoble", "region": {
            "center": {
                "type": "Point", "coordinates": [5.7301, 45.1825]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "gresivaudan", "name": "Grésivaudan", "region": {
            "center": {
                "type": "Point", "coordinates": [5.9674, 45.3101]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "guerande", "name": "Guérande", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.4284, 47.3281]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "gueret", "name": "Guéret", "region": {
            "center": {
                "type": "Point", "coordinates": [1.8714, 46.1657]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "guingamp", "name": "Guingamp", "region": {
            "center": {
                "type": "Point", "coordinates": [-3.1529, 48.5614]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "haguenau", "name": "Haguenau", "region": {
            "center": {
                "type": "Point", "coordinates": [7.8308, 48.8456]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "hendaye-bayonne", "name": "Hendaye Bayonne", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.7574, 43.3664]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "herblay-sur-seine", "name": "Herblay-sur-Seine", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1562, 49.0005]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "honfleur", "name": "Honfleur", "region": {
            "center": {
                "type": "Point", "coordinates": [0.2277, 49.4088]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "houdan", "name": "Houdan", "region": {
            "center": {
                "type": "Point", "coordinates": [1.5966, 48.7956]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "ile-de-re", "name": "Île de Ré", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.3682, 46.2005]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "issoudun", "name": "Issoudun", "region": {
            "center": {
                "type": "Point", "coordinates": [1.9853, 46.9458]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "joigny", "name": "Joigny", "region": {
            "center": {
                "type": "Point", "coordinates": [3.4105, 48.0169]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "l-etang-sale", "name": "L'Étang-Salé", "region": {
            "center": {
                "type": "Point", "coordinates": [55.3621, -21.238]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "la-celle-saint-cloud", "name": "La Celle-Saint-Cloud", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1364, 48.8512]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "la-ciotat", "name": "La Ciotat", "region": {
            "center": {
                "type": "Point", "coordinates": [5.6176, 43.1811]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "la-ferte-sous-jouarre", "name": "La Ferté-sous-Jouarre", "region": {
            "center": {
                "type": "Point", "coordinates": [3.134, 48.9505]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "la-roche-sur-yon", "name": "La Roche sur Yon", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.4231, 46.6676]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "la-rochelle", "name": "La Rochelle", "region": {
            "center": {
                "type": "Point", "coordinates": [5.7281, 47.7504]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lac-du-bourget", "name": "Lac du Bourget", "region": {
            "center": {
                "type": "Point", "coordinates": [5.854, 45.634]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lagny-sur-marne", "name": "Lagny-sur-Marne", "region": {
            "center": {
                "type": "Point", "coordinates": [2.7083, 48.8735]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lamballe", "name": "Lamballe", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.5559, 48.4792]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lamorlaye", "name": "Lamorlaye", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4247, 49.1568]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "landerneau", "name": "Landerneau", "region": {
            "center": {
                "type": "Point", "coordinates": [-4.2645, 48.4512]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "langres", "name": "Langres", "region": {
            "center": {
                "type": "Point", "coordinates": [5.3375, 47.8598]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lannion-tregor", "name": "Lannion - Trégor", "region": {
            "center": {
                "type": "Point", "coordinates": [-3.4634, 48.7427]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lardy", "name": "Lardy", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2639, 48.5231]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "laval", "name": "Laval", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.767, 48.0662]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "le-havre", "name": "Le Havre", "region": {
            "center": {
                "type": "Point", "coordinates": [0.1284, 49.5069]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "le-mans", "name": "Le Mans", "region": {
            "center": {
                "type": "Point", "coordinates": [0.2016, 47.9908]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "le-puy-en-velay", "name": "Le Puy-en-Velay", "region": {
            "center": {
                "type": "Point", "coordinates": [3.893, 45.0315]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lens", "name": "Lens", "region": {
            "center": {
                "type": "Point", "coordinates": [2.8228, 50.4341]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "les-avirons", "name": "Les Avirons", "region": {
            "center": {
                "type": "Point", "coordinates": [55.3609, -21.2068]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "les-clayes-sous-bois", "name": "Les Clayes-sous-Bois", "region": {
            "center": {
                "type": "Point", "coordinates": [1.9818, 48.8168]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "les-sables-d-olonne", "name": "Les Sables d'Olonne", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.7633, 46.5317]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "les-ulis", "name": "Les Ulis", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1843, 48.6806]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "libourne", "name": "Libourne", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.2325, 44.9183]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lieusaint", "name": "Lieusaint", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5541, 48.6274]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lille", "name": "Lille", "region": {
            "center": {
                "type": "Point", "coordinates": [3.0476, 50.6344]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "limoges", "name": "Limoges", "region": {
            "center": {
                "type": "Point", "coordinates": [1.2531, 45.8597]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lisieux", "name": "Lisieux", "region": {
            "center": {
                "type": "Point", "coordinates": [0.2385, 49.145]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "longwy", "name": "Longwy", "region": {
            "center": {
                "type": "Point", "coordinates": [5.7696, 49.521]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lons-le-saunier", "name": "Lons-le-Saunier", "region": {
            "center": {
                "type": "Point", "coordinates": [5.558, 46.6754]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lorient", "name": "Lorient", "region": {
            "center": {
                "type": "Point", "coordinates": [-3.3825, 47.7495]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lourdes", "name": "Lourdes", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.0819, 43.1086]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "louviers", "name": "Louviers", "region": {
            "center": {
                "type": "Point", "coordinates": [1.1471, 49.2261]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "luxeuil-les-bains", "name": "Luxeuil-les-bains", "region": {
            "center": {
                "type": "Point", "coordinates": [6.3701, 47.821]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "lyon", "name": "Lyon", "region": {
            "center": {
                "type": "Point", "coordinates": [4.8236, 45.7685]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "macon", "name": "Mâcon", "region": {
            "center": {
                "type": "Point", "coordinates": [4.8116, 46.3155]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "magny-en-vexin", "name": "Magny-en-Vexin", "region": {
            "center": {
                "type": "Point", "coordinates": [1.8055, 49.1643]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "manosque", "name": "Manosque", "region": {
            "center": {
                "type": "Point", "coordinates": [5.7741, 43.8456]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "mantes-la-jolie", "name": "Mantes la Jolie", "region": {
            "center": {
                "type": "Point", "coordinates": [1.7012, 48.9947]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "maremne-adour", "name": "Maremne Adour", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.2093, 43.6822]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "marines", "name": "Marines", "region": {
            "center": {
                "type": "Point", "coordinates": [1.9841, 49.1495]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "marly-le-roi", "name": "Marly-le-Roi", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0916, 48.8709]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "marmande", "name": "Marmande", "region": {
            "center": {
                "type": "Point", "coordinates": [0.1704, 44.5008]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "marne-la-vallee", "name": "Marne-la-Vallée", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5751, 48.8617]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "marolles-en-hurepoix", "name": "Marolles-en-Hurepoix", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2996, 48.5642]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "marseille", "name": "Marseille", "region": {
            "center": {
                "type": "Point", "coordinates": [5.3722, 43.2545]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "martigues", "name": "Martigues", "region": {
            "center": {
                "type": "Point", "coordinates": [5.0365, 43.367]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "melun", "name": "Melun", "region": {
            "center": {
                "type": "Point", "coordinates": [2.6595, 48.5426]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "mende", "name": "Mende", "region": {
            "center": {
                "type": "Point", "coordinates": [3.4856, 44.5314]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "menton", "name": "Menton", "region": {
            "center": {
                "type": "Point", "coordinates": [7.491, 43.7967]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "metz", "name": "Metz", "region": {
            "center": {
                "type": "Point", "coordinates": [6.1906, 49.1115]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "meulan-en-yvelines", "name": "Meulan-en-Yvelines", "region": {
            "center": {
                "type": "Point", "coordinates": [1.9112, 49.0084]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "millau", "name": "Millau", "region": {
            "center": {
                "type": "Point", "coordinates": [3.1072, 44.1121]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "milly-la-foret", "name": "Milly-la-Forêt", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4486, 48.4035]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "miribel", "name": "Miribel", "region": {
            "center": {
                "type": "Point", "coordinates": [4.9376, 45.8426]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "monaco", "name": "Monaco", "region": {
            "center": {
                "type": "Point", "coordinates": [7.4209, 43.7477]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "mont-de-marsan", "name": "Mont-de-Marsan", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.4844, 43.8925]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montargis", "name": "Montargis", "region": {
            "center": {
                "type": "Point", "coordinates": [2.7361, 47.996]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montauban", "name": "Montauban", "region": {
            "center": {
                "type": "Point", "coordinates": [1.3736, 44.022]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montbeliard", "name": "Montbeliard", "region": {
            "center": {
                "type": "Point", "coordinates": [6.79, 47.5189]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montelimar", "name": "Montélimar", "region": {
            "center": {
                "type": "Point", "coordinates": [4.7457, 44.5555]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montereau-fault-yonne", "name": "Montereau-Fault-Yonne", "region": {
            "center": {
                "type": "Point", "coordinates": [2.9646, 48.3891]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montesson", "name": "Montesson", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1433, 48.9135]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montlhery", "name": "Montlhéry", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2699, 48.6409]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montlucon", "name": "Montluçon", "region": {
            "center": {
                "type": "Point", "coordinates": [2.603, 46.3422]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montmorency", "name": "Montmorency", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3205, 48.9935]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "montpellier", "name": "Montpellier", "region": {
            "center": {
                "type": "Point", "coordinates": [3.8592, 43.6183]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "moselle-et-madon", "name": "Moselle et Madon", "region": {
            "center": {
                "type": "Point", "coordinates": [6.1086, 48.6169]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "moulins", "name": "Moulins", "region": {
            "center": {
                "type": "Point", "coordinates": [3.6796, 49.418]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "mulhouse", "name": "Mulhouse", "region": {
            "center": {
                "type": "Point", "coordinates": [7.3289, 47.7491]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nancy", "name": "Nancy", "region": {
            "center": {
                "type": "Point", "coordinates": [6.1709, 48.6889]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nantes", "name": "Nantes", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.5492, 47.2397]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nemours", "name": "Nemours", "region": {
            "center": {
                "type": "Point", "coordinates": [2.7112, 48.2588]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "neufchateau", "name": "Neufchâteau", "region": {
            "center": {
                "type": "Point", "coordinates": [5.6962, 48.3568]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nevers", "name": "Nevers", "region": {
            "center": {
                "type": "Point", "coordinates": [3.1609, 46.9892]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nice", "name": "Nice", "region": {
            "center": {
                "type": "Point", "coordinates": [7.2651, 43.7123]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nimes", "name": "Nîmes", "region": {
            "center": {
                "type": "Point", "coordinates": [4.346, 43.8425]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "niort", "name": "Niort", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.4678, 46.3265]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nogent-le-rotrou", "name": "Nogent-le-Rotrou", "region": {
            "center": {
                "type": "Point", "coordinates": [0.8079, 48.3153]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "noumea", "name": "Nouméa", "region": {
            "center": {
                "type": "Point", "coordinates": [166.442419, -22.2745264]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "noyon", "name": "Noyon", "region": {
            "center": {
                "type": "Point", "coordinates": [3.0127, 49.5736]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "nyons", "name": "Nyons", "region": {
            "center": {
                "type": "Point", "coordinates": [5.1174, 44.3567]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "obernai", "name": "Obernai", "region": {
            "center": {
                "type": "Point", "coordinates": [7.4649, 48.4544]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "orange", "name": "Orange", "region": {
            "center": {
                "type": "Point", "coordinates": [4.8036, 44.1277]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "orleans", "name": "Orléans", "region": {
            "center": {
                "type": "Point", "coordinates": [1.9172, 47.8828]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "orsay", "name": "Orsay", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1887, 48.6963]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "oyonnax", "name": "Oyonnax", "region": {
            "center": {
                "type": "Point", "coordinates": [5.6361, 46.27]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "panoramique-des-domes", "name": "Panoramique des Dômes", "region": {
            "center": {
                "type": "Point", "coordinates": [3.0134, 45.7162]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "paray-le-monial", "name": "Paray-le-Monial", "region": {
            "center": {
                "type": "Point", "coordinates": [4.1124, 46.4489]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "paris", "name": "Paris", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3752, 48.845]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pau", "name": "Pau", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.3462, 43.3197]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pays-basque", "name": "Pays Basque", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.6407, 43.3939]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pays-de-l-or", "name": "Pays de l'Or", "region": {
            "center": {
                "type": "Point", "coordinates": [4.0344, 43.5914]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pays-de-l-ourcq", "name": "Pays de l'Ourcq", "region": {
            "center": {
                "type": "Point", "coordinates": [3.0251, 49.0342]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pays-de-meaux", "name": "Pays de Meaux", "region": {
            "center": {
                "type": "Point", "coordinates": [2.8943, 48.9563]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pays-du-lunevillois", "name": "Pays du Lunévillois", "region": {
            "center": {
                "type": "Point", "coordinates": [6.5018, 48.5893]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "perigueux", "name": "Périgueux", "region": {
            "center": {
                "type": "Point", "coordinates": [0.7082, 45.1947]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "perpignan", "name": "Perpignan", "region": {
            "center": {
                "type": "Point", "coordinates": [2.8972, 42.7018]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "petite-ile", "name": "Petite-Île", "region": {
            "center": {
                "type": "Point", "coordinates": [55.5761, -21.3389]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "ploermel", "name": "Ploërmel", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.3744, 47.9163]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pointe-a-pitre", "name": "Pointe-à-Pitre", "region": {
            "center": {
                "type": "Point", "coordinates": [-61.5354, 16.2282]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "poissy", "name": "Poissy", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0237, 48.923]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "poitiers", "name": "Poitiers", "region": {
            "center": {
                "type": "Point", "coordinates": [0.3631, 46.5822]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "poitiers-parthenay", "name": "Poitiers Parthenay", "region": {
            "center": {
                "type": "Point", "coordinates": [0.3631, 46.5822]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pont-audemer", "name": "Pont-Audemer", "region": {
            "center": {
                "type": "Point", "coordinates": [0.5257, 49.345]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pont-sainte-maxence", "name": "Pont-Sainte-Maxence", "region": {
            "center": {
                "type": "Point", "coordinates": [2.6078, 49.3097]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pont-a-mousson", "name": "Pont à Mousson", "region": {
            "center": {
                "type": "Point", "coordinates": [6.0589, 48.9213]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pontarlier", "name": "Pontarlier", "region": {
            "center": {
                "type": "Point", "coordinates": [6.3895, 46.9147]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pontault-combault", "name": "Pontault-Combault", "region": {
            "center": {
                "type": "Point", "coordinates": [2.6159, 48.7851]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pontivy", "name": "Pontivy", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.9702, 48.0702]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pontorson-mont-saint-michel", "name": "Pontorson - Mont-Saint-Michel", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.4572, 48.5551]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "pringy", "name": "Pringy", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5479, 48.5164]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "privas", "name": "Privas", "region": {
            "center": {
                "type": "Point", "coordinates": [4.5914, 44.7238]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "provins", "name": "Provins", "region": {
            "center": {
                "type": "Point", "coordinates": [3.2959, 48.5639]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "quimper", "name": "Quimper", "region": {
            "center": {
                "type": "Point", "coordinates": [-4.0916, 47.9914]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "quimperle", "name": "Quimperlé", "region": {
            "center": {
                "type": "Point", "coordinates": [-3.5552, 47.8549]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "rambouillet", "name": "Rambouillet", "region": {
            "center": {
                "type": "Point", "coordinates": [1.8362, 48.6476]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "reims", "name": "Reims", "region": {
            "center": {
                "type": "Point", "coordinates": [4.0438, 49.2484]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "rennes", "name": "Rennes", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.6815, 48.1105]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "riom", "name": "Riom", "region": {
            "center": {
                "type": "Point", "coordinates": [3.12, 45.8938]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "roanne", "name": "Roanne", "region": {
            "center": {
                "type": "Point", "coordinates": [4.0808, 46.0425]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "rochefort", "name": "Rochefort", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.9726, 45.9512]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "rodez", "name": "Rodez", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5693, 44.3579]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "roissy-en-brie", "name": "Roissy-en-Brie", "region": {
            "center": {
                "type": "Point", "coordinates": [2.6521, 48.7893]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "roissy-en-france", "name": "Roissy-en-France", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5138, 49.0021]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "rosny-sous-bois", "name": "Rosny-sous-Bois", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4862, 48.8746]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "rouen", "name": "Rouen", "region": {
            "center": {
                "type": "Point", "coordinates": [1.0984, 49.4432]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "royan", "name": "Royan", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.0242, 45.6314]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "rumilly", "name": "Rumilly", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0159, 50.5798]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sable-sur-sarthe", "name": "Sablé-sur-Sarthe", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.3603, 47.8414]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-amand-montrond", "name": "Saint-Amand-Montrond", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5169, 46.7265]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-avold-synergie", "name": "Saint-Avold Synergie", "region": {
            "center": {
                "type": "Point", "coordinates": [6.702, 49.0814]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-brevin-les-pins", "name": "Saint-Brevin-les-Pins", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.1572, 47.2334]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-brieuc", "name": "Saint-Brieuc", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.7639, 48.5157]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-cyr-l-ecole", "name": "Saint-Cyr-l'École", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0672, 48.8096]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-die-des-vosges", "name": "Saint-Dié-des-Vosges", "region": {
            "center": {
                "type": "Point", "coordinates": [6.9337, 48.2937]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-dizier", "name": "Saint-Dizier", "region": {
            "center": {
                "type": "Point", "coordinates": [4.9459, 48.64]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-etienne", "name": "Saint-Étienne", "region": {
            "center": {
                "type": "Point", "coordinates": [4.3807, 45.4283]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-germain-en-laye", "name": "Saint-Germain-en-Laye", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0864, 48.9194]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-germain-les-corbeil", "name": "Saint-Germain-lès-Corbeil", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4904, 48.6249]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-gilles-croix-de-vie", "name": "Saint-Gilles-Croix-de-Vie", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.922, 46.6918]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-hilaire-de-riez", "name": "Saint-Hilaire-de-Riez", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.9663, 46.7456]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-lo", "name": "Saint-Lô", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.0835, 49.1072]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-louis", "name": "Saint-Louis", "region": {
            "center": {
                "type": "Point", "coordinates": [-61.2733, 15.9705]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-louis-de-la-reunion", "name": "Saint-Louis de la Réunion", "region": {
            "center": {
                "type": "Point", "coordinates": [55.4233, -21.2179]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-malo", "name": "Saint-Malo", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.9987, 48.6491]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-nazaire", "name": "Saint-Nazaire", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.2463, 47.2747]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-omer", "name": "Saint-Omer", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.4464, 48.93]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-pierre-de-la-reunion", "name": "Saint-Pierre de la Réunion", "region": {
            "center": {
                "type": "Point", "coordinates": [55.5113, -21.3187]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-quentin", "name": "Saint-Quentin", "region": {
            "center": {
                "type": "Point", "coordinates": [3.2889, 49.8457]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saint-raphael", "name": "Saint-Raphaël", "region": {
            "center": {
                "type": "Point", "coordinates": [1.076, 45.304]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sainte-genevieve-des-bois", "name": "Sainte-Geneviève-des-Bois", "region": {
            "center": {
                "type": "Point", "coordinates": [2.3245, 48.6424]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sainte-maxime", "name": "Sainte-Maxime", "region": {
            "center": {
                "type": "Point", "coordinates": [6.6094, 43.3493]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sainte-menehould", "name": "Sainte-Menehould", "region": {
            "center": {
                "type": "Point", "coordinates": [4.9283, 49.0921]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saintes", "name": "Saintes", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.6519, 45.742]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "salon-de-provence", "name": "Salon-de-Provence", "region": {
            "center": {
                "type": "Point", "coordinates": [5.1075, 43.6423]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "samois-sur-seine", "name": "Samois-sur-Seine", "region": {
            "center": {
                "type": "Point", "coordinates": [2.7506, 48.4522]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sannois", "name": "Sannois", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2508, 48.9713]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sarrebourg", "name": "Sarrebourg", "region": {
            "center": {
                "type": "Point", "coordinates": [7.0607, 48.7395]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sarreguemines", "name": "Sarreguemines", "region": {
            "center": {
                "type": "Point", "coordinates": [7.0673, 49.1039]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "saumur", "name": "Saumur", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.0831, 47.2612]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sel-et-vermois", "name": "Sel et Vermois", "region": {
            "center": {
                "type": "Point", "coordinates": [6.3598, 48.6218]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "selestat", "name": "Sélestat", "region": {
            "center": {
                "type": "Point", "coordinates": [7.4678, 48.2516]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "senlis", "name": "Senlis", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5858, 49.2087]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sens", "name": "Sens", "region": {
            "center": {
                "type": "Point", "coordinates": [3.3042, 48.1972]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sete", "name": "Sète", "region": {
            "center": {
                "type": "Point", "coordinates": [3.6624, 43.3856]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "shawinigan", "name": "Shawinigan", "region": {
            "center": {
                "type": "Point", "coordinates": [-73.1614598, 46.6893421]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sorgues", "name": "Sorgues", "region": {
            "center": {
                "type": "Point", "coordinates": [4.873, 44.0196]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "strasbourg", "name": "Strasbourg", "region": {
            "center": {
                "type": "Point", "coordinates": [7.7553, 48.5673]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "sucy-en-brie", "name": "Sucy-en-Brie", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5307, 48.771]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "thiers", "name": "Thiers", "region": {
            "center": {
                "type": "Point", "coordinates": [3.5456, 45.868]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "thionville", "name": "Thionville", "region": {
            "center": {
                "type": "Point", "coordinates": [6.1412, 49.3726]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "thonon-les-bains", "name": "Thonon-les-Bains", "region": {
            "center": {
                "type": "Point", "coordinates": [6.4774, 46.3705]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "toul", "name": "Toul", "region": {
            "center": {
                "type": "Point", "coordinates": [5.8926, 48.6812]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "toulon", "name": "Toulon", "region": {
            "center": {
                "type": "Point", "coordinates": [5.9306, 43.1249]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "toulouse", "name": "Toulouse", "region": {
            "center": {
                "type": "Point", "coordinates": [1.4368, 43.6089]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "tours", "name": "Tours", "region": {
            "center": {
                "type": "Point", "coordinates": [0.6947, 47.3952]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "trappes", "name": "Trappes", "region": {
            "center": {
                "type": "Point", "coordinates": [1.9906, 48.7725]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "trevoux", "name": "Trévoux", "region": {
            "center": {
                "type": "Point", "coordinates": [4.7642, 45.944]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "troyes", "name": "Troyes", "region": {
            "center": {
                "type": "Point", "coordinates": [4.082, 48.2981]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "tulle", "name": "Tulle", "region": {
            "center": {
                "type": "Point", "coordinates": [1.7597, 45.2744]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "val-briard", "name": "Val Briard", "region": {
            "center": {
                "type": "Point", "coordinates": [2.9614, 48.6823]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "valenciennes", "name": "Valenciennes", "region": {
            "center": {
                "type": "Point", "coordinates": [3.5195, 50.3626]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vannes", "name": "Vannes", "region": {
            "center": {
                "type": "Point", "coordinates": [-2.749, 47.6559]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "velizy-villacoublay", "name": "Vélizy-Villacoublay", "region": {
            "center": {
                "type": "Point", "coordinates": [2.2001, 48.7826]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vendome", "name": "Vendôme", "region": {
            "center": {
                "type": "Point", "coordinates": [1.0673, 47.797]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "verdun", "name": "Verdun", "region": {
            "center": {
                "type": "Point", "coordinates": [5.3644, 49.1464]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vernon-les-andelys", "name": "Vernon - Les Andelys", "region": {
            "center": {
                "type": "Point", "coordinates": [1.4953, 49.0912]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vernouillet", "name": "Vernouillet", "region": {
            "center": {
                "type": "Point", "coordinates": [1.9742, 48.965]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "versailles", "name": "Versailles", "region": {
            "center": {
                "type": "Point", "coordinates": [2.1325, 48.8032]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vesoul", "name": "Vesoul", "region": {
            "center": {
                "type": "Point", "coordinates": [6.1513, 47.633]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vichy", "name": "Vichy", "region": {
            "center": {
                "type": "Point", "coordinates": [3.4274, 46.1306]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vienne", "name": "Vienne", "region": {
            "center": {
                "type": "Point", "coordinates": [4.8822, 45.5214]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vierzon", "name": "Vierzon", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0737, 47.2205]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vigneux-sur-seine", "name": "Vigneux-sur-Seine", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4346, 48.7033]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "villecresnes", "name": "Villecresnes", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5315, 48.7188]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "villefranche-sur-saone", "name": "Villefranche-sur-Saône", "region": {
            "center": {
                "type": "Point", "coordinates": [4.724, 45.9863]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "villeneuve-le-roi", "name": "Villeneuve-le-Roi", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4126, 48.7316]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "villeneuve-les-sablons", "name": "Villeneuve-les-Sablons", "region": {
            "center": {
                "type": "Point", "coordinates": [2.0718, 49.2336]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "villeneuve-sur-lot", "name": "Villeneuve-sur-Lot", "region": {
            "center": {
                "type": "Point", "coordinates": [0.7424, 44.4323]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "villepinte", "name": "Villepinte", "region": {
            "center": {
                "type": "Point", "coordinates": [2.5373, 48.9594]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "villers-cotterets", "name": "Villers Cotterets", "region": {
            "center": {
                "type": "Point", "coordinates": [3.0842, 49.208]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vire", "name": "Vire", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.8795, 48.8156]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "vitre", "name": "Vitré", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.1889, 48.1089]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "voiron", "name": "Voiron", "region": {
            "center": {
                "type": "Point", "coordinates": [5.5843, 45.3773]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "yerres", "name": "Yerres", "region": {
            "center": {
                "type": "Point", "coordinates": [2.4894, 48.7126]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "yvetot", "name": "Yvetot", "region": {
            "center": {
                "type": "Point", "coordinates": [0.7662, 49.6165]
            }
        }
        , "osmLevel": 8
    }
    ,
    {
        "id": "aube", "name": "Aube", "region": {
            "center": {
                "type": "Point", "coordinates": [4.1171, 48.311]
            }
        }
        , "osmLevel": 6
    }
    ,
    {
        "id": "dordogne", "name": "Dordogne", "region": {
            "center": {
                "type": "Point", "coordinates": [0.72005, 45.1412]
            }
        }
        , "osmLevel": 6
    }
    ,
    {
        "id": "haute-garonne", "name": "Haute-Garonne", "region": {
            "center": {
                "type": "Point", "coordinates": [1.23605, 43.3152]
            }
        }
        , "osmLevel": 6
    }
    ,
    {
        "id": "les-yvelines-lignes-express-les-mureaux",
        "name": "Les Yvelines - Lignes Express les Mureaux",
        "region": {
            "center": {
                "type": "Point", "coordinates": [1.8392, 48.7681]
            }
        }
        ,
        "osmLevel": 6
    }
    ,
    {
        "id": "loire-atlantique", "name": "Loire Atlantique", "region": {
            "center": {
                "type": "Point", "coordinates": [-1.76225, 47.35905]
            }
        }
        , "osmLevel": 6
    }
    ,
    {
        "id": "mayenne", "name": "Mayenne", "region": {
            "center": {
                "type": "Point", "coordinates": [-0.63035, 48.1433]
            }
        }
        , "osmLevel": 6
    }
    ,
    {
        "id": "transisere", "name": "Transisère - Lignes régulières", "region": {
            "center": {
                "type": "Point", "coordinates": [5.5114, 45.30225]
            }
        }
        , "osmLevel": 6
    }
    ,
    {
        "id": "hauts-de-france", "name": "Hauts de France", "region": {
            "center": {
                "type": "Point", "coordinates": [2.95105, 49.97195]
            }
        }
        , "osmLevel": 4
    }
];